import { render } from "./AiServiceCoupons.vue?vue&type=template&id=a2a0f4b6"
import script from "./AiServiceCoupons.vue?vue&type=script&lang=js"
export * from "./AiServiceCoupons.vue?vue&type=script&lang=js"

import "./AiServiceCoupons.vue?vue&type=style&index=0&id=a2a0f4b6&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiServiceCoupons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2a0f4b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2a0f4b6', __exports__)) {
    api.reload('a2a0f4b6', __exports__)
  }
  
  module.hot.accept("./AiServiceCoupons.vue?vue&type=template&id=a2a0f4b6", () => {
    api.rerender('a2a0f4b6', render)
  })

}


export default __exports__